var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.anchorLinkClasses},[_c('a',{class:_vm.linkTitleClasses,attrs:{"href":"javascript:void(0)","data-href":_vm.href,"title":_vm.title},on:{"click":function($event){return _vm.goAnchor(_vm.href)}}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }